exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ContinuityChip_root{border-radius:5px;background-color:#7e92ff;color:white;padding:4px 12px}\n", ""]);

// Exports
exports.locals = {
	"root": "ContinuityChip_root"
};